// extracted by mini-css-extract-plugin
export var dropdownButton = "_3s-0";
export var fullWidthDropdownButton = "_3s-1";
export var icon = "_3s-3";
export var iconPlaceholder = "_3s-2";
export var menuItemRow = "_3s-8";
export var separator = "_3s-c";
export var shortcutContainer = "_3s-7";
export var shortcutIconLg = "_3s-6";
export var shortcutIconMd = "_3s-5";
export var shortcutIconSm = "_3s-4";
export var submenuChevron = "_3s-b";
export var submenuDropdown = "_3s-9";
export var submenuTriggerRow = "_3s-a";